import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dropzoneContainer: {
    marginBottom: '20px',
    textAlign: 'left',
    maxWidth: '600px',
  },
  dropzoneLabel: {
    marginBottom: '4px',
  },
  headerContainer: {
    textAlign: 'left',
    marginBottom: '16px',
  },
  heading: {
    marginBottom: '6px',
  },
  radioGroup: {
    marginBottom: '20px',
  },
  radioButton: {
    marginTop: '10px',
  },
  radioInput: {
    '& input[type="radio"]': {
      display: 'none',
    },
  },
});
